const RegionStatusTemplate = (props: any): any => (props.active ? "Active" : "Inactive");

export default RegionStatusTemplate;
